export function payWithFlutterwave({ public_key, amount, email, name, currency = "NGN", callback }) {

    window.FlutterwaveCheckout({
        // public_key: process.env.VUE_APP_FLUTTERWAVE_PUBLIC_KEY,
        public_key: public_key,
        tx_ref: "TX-" + Date.now(),
        amount: amount,
        currency: currency,
        payment_options: "card,banktransfer,ussd",

        customer: {
            email: email,
            name: name,
        },

        customizations: {
            title: "Mapiibs Payment",
            description: "Payment for Subscription",
            logo: "../public/static/logo.png",
        },

        callback: function (data) {
            if (callback) callback(data);
        },

        onclose: function () {
            console.log("Payment cancelled");
        }
    });

}